import { FilterValues } from "../../../data-model/filterValues";
import { AsteraOncologyExternalFilterKeys } from "./createFilterSections";

export interface ProcessedFilterData {
  filters: { [key: string]: string[] | null };
  biosimilarStates: string[];
}

/**
 * Converts a date string to YYYY-MM-DD format for the dumped_at filter
 */
const convertDateToDumpedAtFormat = (dateStr: string): string => {
  // Check if already in YYYYMMDD format (8 digits)
  if (/^\d{8}$/.test(dateStr)) {
    const year = dateStr.substring(0, 4);
    const month = dateStr.substring(4, 6);
    const day = dateStr.substring(6, 8);
    return `${year}-${month}-${day}`;
  }

  // Try to parse the date
  const date = new Date(dateStr);

  if (isNaN(date.getTime())) {
    return dateStr;
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

/**
 *
 * Converts default date (YYYYMMDD format) to YYYY-MM-DD format for dumped_at filter
 */
export const convertDefaultDateToDumpedAtFormat = (dateStr: string): string => {
  return convertDateToDumpedAtFormat(dateStr);
};

export const processFilterData = (
  validFilters: FilterValues[],
): ProcessedFilterData => {
  const filters: { [key: string]: string[] | null } = {};
  const biosimilarStates: string[] = [];

  if (!validFilters || validFilters.length === 0) {
    return { filters, biosimilarStates };
  }

  const filter = validFilters[0];

  if (!filter || !filter.values) {
    return { filters, biosimilarStates };
  }

  Object.entries(filter.values).forEach(([filterId, filterData]) => {
    const selectedValues = filterData.values || [];

    if (selectedValues.length > 0) {
      switch (filterId) {
        case AsteraOncologyExternalFilterKeys.PA_STATUS:
          filters.response_status = selectedValues;
          break;
        case AsteraOncologyExternalFilterKeys.PA_STATUS_BUCKET:
          filters.pa_outcome_classification = selectedValues;
          break;
        case AsteraOncologyExternalFilterKeys.BIOSIMILAR:
          biosimilarStates.push(...selectedValues);
          break;
        case AsteraOncologyExternalFilterKeys.DOW:
          // Date range from filter (e.g. MM/DD/YYYY) -> YYYY-MM-DD for payload
          if (selectedValues.length >= 2) {
            filters.dumped_at = selectedValues.map(convertDateToDumpedAtFormat);
          }
          break;
        default:
          break;
      }
    }
  });

  return { filters, biosimilarStates };
};
